import { createFileRoute } from '@tanstack/react-router';

import { ShowcaseView } from 'src/sections/admin/showcase';

export const Route = createFileRoute('/admin-skidog/showcase')({
  component: ShowcaseView,
});
